import { CreateExamPaper } from './CreateExamPaper';
export default CreateExamPaper;
